import * as THREE from 'three';
import { Scene, OrthographicCamera, WebGLRenderer, Vector3 } from 'three';
import { RttScene } from './RttScene';
import { RttScene2 } from './RttScene2';
import { RttSceneMid } from './RttSceneMid';

export class RttScenes extends THREE.Object3D{

    scenes:RttScene[];

    constructor(){
        super();

        this.scenes = [
            new RttScene(),
            //new RttScene1(),
            //new RttSceneMid(),
            new RttScene2()
        ];

        for(let i=0;i<this.scenes.length;i++){
            let s = this.scenes[i];
            s.position.x = 110*(i+1);
            this.add(s);
        }

    }

    getTexture():THREE.Texture{
        return this.scenes[0].renderTarget.texture;
    }
    
    addImpulse(xx:number,yy:number){

        for(let i=0;i<this.scenes.length;i++){
            this.scenes[i].addImpulse(xx,yy);
        }

    }

    //入力を入れる
    update(renderer:WebGLRenderer,tex:THREE.Texture){

        //console.log(""+tex);

        for(let i=0;i<this.scenes.length;i++){
            let n = i-1;
            if(n<0) n = this.scenes.length-1;
            this.scenes[i].setTexture(
                this.scenes[n].renderTarget.texture,
                tex
            );
            this.scenes[i].update(renderer);
        }
        
    }

}